export enum HIERARCHY_LEVEL {
  DIVISION = "DIVISION",
  AREA = "AREA",
  DEPARTMENT = "DEPARTAMENTO",
  LINE = "LINEA",
  SECTION = "SECCION",
  FAMILY = "FAMILIA",
  SUBFAMILY = "SUBFAMILIA"
}